export const tr = {
    'moderation-pending': 'Operatör onayı bekleniyor',
    'moderation-rejected': 'Bazı operatörler tarafından reddedildi'
};
